import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { NewRelicService } from '../../../../../../angular-app/projects/brokerage-eapp/src/app/services/newrelic.service';
import { FormGroup, FormControl } from '@angular/forms';
import { Observable, of, Subject, Subscription } from 'rxjs';

import { QuestionBase } from 'src/app/models/question-base';
import { QuestionControlService } from '../services/question-control.service';
import { ProcessorService } from '../services/processor.service';
import { ApiService } from 'src/app/services/api.service';

// models
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { first, map, takeUntil } from 'rxjs/operators';

// store
import { AppState } from '../app-reducer';

// util
import { find, get } from 'lodash';
import { NavigationService } from '../services/navigation.service';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'thank-you',
  templateUrl: './thank-you.component.html'
})
export class ThankYouComponent implements OnInit, OnDestroy {
  @Input() questions: QuestionBase<any>[] = [];
  thankYouForm: FormGroup;
  thankYouFormSubs: Subscription;
  sectionBlock: string;
  sectionData: any;
  appState$: Observable<any>;
  appId: string;
  appAuthId: string;
  processing: boolean;
  agentFirstName: string;
  agentLastName: string;
  firstName: string;
  lastName: string;
  agentPhone: string;
  questions$: Observable<QuestionBase<any>[]>;
  isDemo = false;
  isOwner = false;
  hasOwners = false;
  private _onDestroy = new Subject();
  AgentId: string;
  internalInterval: any;
  timeout: number = 3 * 60;
  timeLeft: number = 3 * 60;
  PendingJobsCounter: any = 0;
  emailFailedMsg= 'failed. mail not sent';
  agentAttestation= false;

  constructor(
    private newRelicService: NewRelicService,
    public route: ActivatedRoute,
    private store: Store<AppState>,
    private qcs: QuestionControlService,
    private processorService: ProcessorService,
    private apiService: ApiService,
    private changeDetection: ChangeDetectorRef,
    private navigationService: NavigationService,
    private commonService: CommonService
  ) {
    // section data
    this.sectionData = route.snapshot.data;
    this.appState$ = store.select('sections');
    this.sectionBlock = this.sectionData.blockName;
  }

  ngOnInit() {
    this.appState$.pipe(first()).subscribe((state: any) => {
      this.appId = get(state, 'appId');
      this.newRelicService.addPageAction('Page Loaded', { appId: this.appId });
      this.newRelicService.setPageViewName('Thank You Page');
      this.newRelicService.setCurrentRouteName('Thank You Route');

      this.commonService.logAppState(state);

      if (state.questions) {
        const section: any = find(state.questions, { Name: this.sectionBlock });
        this.questions = section.Questions;
        this.questions$ = of(this.questions);
      }

      this.AgentId = (window['jhConfig'].ivuser !== '') ? window['jhConfig'].ivuser : 'DreamFinFit';
      this.appAuthId = get(state, 'appAuthId');
      if (state.isDemo) {
        this.isDemo = true;
      }
      this.firstName = state["content"]["SECTIONAProposedInsured"]["Name"]["FirstName"] || 'First Name not found';
      this.lastName = state["content"]["SECTIONAProposedInsured"]["Name"]["LastName"] || 'Last Name not found';
      this.hasOwners = state["content"]["SECTIONBPolicyOwner"] ? (state["content"]["SECTIONBPolicyOwner"]["PolicyOwnerInsured"] == 'SoleOwner' ? false : (state["content"]["SECTIONBPolicyOwner"]["PolicyOwnerInformation"] ? (state["content"]["SECTIONBPolicyOwner"]["PolicyOwnerInformation"].length > 0 ? true : false) : false)) : false;

      this.isOwner = (state.userRole.name.includes('Owner') && !state.userRole.name.includes('Insured') && !this.isDemo) ? true : false;
      this.agentAttestation = state["content"]["SECTIONAProposedInsured"]["AgentAttestation"] || false;

      this.removeInsuredAppSubmittedQuestion();
      if (this.isDemo) {
        this.demoThankYou();
      } else if (this.isOwner) {
        this.processing = true;
        this.ownerThankYou();
      } else {
        this.getAgents();
      }
    });

    // Terminate proposed insured flow in JHADE
    const signaturePayload = {
      AppId: this.appId,
      appAuthId: this.appAuthId
    };
    if (this.isDemo) {
      this.apiService.demoCustomerSignedApplication(signaturePayload).subscribe((response) => {
        this.newRelicService.addPageAction('Demo Customer Signed', { appId: this.appId });
        console.log('Eval: ', response);
      }, (error) => {
        this.newRelicService.noticeError(error);
        console.log(error);
      });
    } else if (this.isOwner) {
      // let resumePayload = {
      //   AppId: this.appId,
      //   AppAuthId: this.appAuthId
      // };
      // //check if it's the last owner to sign, send email to agent to finish app
      // this.checkForPendingJobs(resumePayload);
    } else {
      console.log('has owners:', this.hasOwners);
      //check if PI is sole owner or there are other owners
      //if owners-> use customer signed with owners and send owner emails
      //else use regular customer signed
      if (this.hasOwners) {
        if (this.agentAttestation) {
          //omit Agent email for external app cases, only send agent emails
          this.sendOwnerEmails();
        } else {
          this.apiService.customerSignedWithOwners(signaturePayload).subscribe((response) => {
            this.newRelicService.addPageAction('Customer Signed With Owners', { appId: this.appId });
            this.sendOwnerEmails();
            console.log('Eval: ', response);
          }, (error) => {
            this.newRelicService.noticeError(error);
            console.log(error);
          });
        }
      } else {
        this.apiService.customerSignedApplication(signaturePayload).subscribe((response) => {
          this.newRelicService.addPageAction('Customer Signed Application', { appId: this.appId });
          console.log('Eval: ', response);
        }, (error) => {
          this.newRelicService.noticeError(error);
          console.log(error);
        });
      }
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this.newRelicService.addPageAction('Component Destroyed', { appId: this.appId });
  }

  checkForPendingJobs(resumePayload: any) {
    this.processing = true;
    this.newRelicService.addPageAction('Check For Pending Jobs', { appId: this.appId });

    // disable the next button while checking for pending jobs and polling for PDF
    if (this.timeLeft > 0) {
      this.navigationService.disableButton(true);

      this.apiService.resumeApplication(resumePayload).pipe(takeUntil(this._onDestroy)).subscribe(response => {
        const count = response.data.PendingJobs === 'jhade' ? 'jhade queue still processing' : response.data.PendingJobs;
        this.commonService.logMessage('pending jobs count', count);
        if (count) {
          if (this.PendingJobsCounter === count) {
            setTimeout(() => this.delayCall(resumePayload), 3000);
          } else {
            this.checkForPendingJobs(resumePayload);
          }
          this.PendingJobsCounter = count;
        } else {
          this.allOwnersSigned(resumePayload);
        }
      }, (error) => {
        this.newRelicService.noticeError(error);
        console.log(error);
      });
    }
  }

  delayCall(resumePayload: any) {
    this.checkForPendingJobs(resumePayload);
  }

  allOwnersSigned(resumePayload: any) {
    this.processing = true;
    this.newRelicService.addPageAction('All Owners Signed', { appId: this.appId });

    //owner signatories payload requires capital AppAuthId instead of smallcase
    const payload = {
      'AppId': this.appId,
      'appAuthId': this.appAuthId
    };
    this.apiService.getOwnerSignatories(resumePayload).subscribe(response => {
      if (response.code === 200 && response.data) {
        if (response.data.OwnershipSignatories.filter(owner => owner.Signed == false).length == 0) {
          this.apiService.ownersSignedApplication(payload).subscribe((ownersSignedAppResponse) => {
            this.newRelicService.addPageAction('Owners Signed Application', { appId: this.appId });
            console.log('Eval: ', ownersSignedAppResponse);
          }, (error) => {
            this.newRelicService.noticeError(error);
            console.log(error);
          });
        }
      }
    }, (error) => {
      this.newRelicService.noticeError(error);
      console.log(error);
    });
    this.processing = false;
    this.changeDetection.detectChanges();
  }

  sendOwnerEmails() {
    this.appState$.pipe(first()).subscribe((state: any) => {
      const owners = state["content"]["SECTIONBPolicyOwner"]["PolicyOwnerInformation"];
      if (owners) {
        const proposedInsuredName = state["content"]["SECTIONAProposedInsured"]["Name"]["FirstName"] + ' ' + state["content"]["SECTIONAProposedInsured"]["Name"]["LastName"];
        owners.forEach(owner => {
          let emailInfo;
          if (owner["PolicyOwnerType"] == 'Individual') {
            const ownerEmail = owner["PolicyOwnerEmail"];
            const ownerFirstName = owner["PolicyOwnerName"]["FirstName"];
            const ownerLastName = owner["PolicyOwnerName"]["LastName"];
            emailInfo = {
              emailInfo: {
                AppId: this.appId,
                Subject: 'Brokerage eApp',
                OwnerLastName: ownerLastName,
                OwnerFirstName: ownerFirstName,
                OwnerType: 'IndividualOwner',
                To: [
                  {
                    email: ownerEmail, name: proposedInsuredName
                  }]
              }
            };
            try {
              this.apiService.sendOwnerEmail(emailInfo).subscribe((response) => {
                if (response.data.Message === 'Mail Sent') {
                  this.newRelicService.addPageAction('Owner Email Sent', { appId: this.appId });
                  console.log('success. mail sent');
                } else {
                  this.commonService.logMessage(this.emailFailedMsg);
                }
              }, (error) => {
                this.newRelicService.noticeError(error);
                console.log(error);
                this.commonService.logMessage(this.emailFailedMsg); //change to retry after
              });
            } catch (e) {
              this.newRelicService.noticeError(e);
              console.log(e);
              this.commonService.logMessage(this.emailFailedMsg); //change to retry after
            }
          } else if (owner["PolicyOwnerType"] == 'Business' || owner["PolicyOwnerType"] == 'ExistingTrust' || owner["PolicyOwnerType"] == 'TrustToBeEstablished' || owner["PolicyOwnerType"] == 'Other') {
            const signingOfficers = owner["SigningOfficerCompound"];
            if (signingOfficers) {
              signingOfficers.forEach(signingOfficer => {
                const ownerType = this.getOwnerType(owner, signingOfficer);
                const signatorEmail = signingOfficer["SigningOfficerEmail"];
                const signatorFirstName = signingOfficer["SigningOfficerName"]["FirstName"];
                const signatorLastName = signingOfficer["SigningOfficerName"]["LastName"];
                emailInfo = {
                  emailInfo: {
                    AppId: this.appId,
                    Subject: 'Brokerage eApp',
                    OwnerLastName: signatorLastName,
                    OwnerFirstName: signatorFirstName,
                    OwnerType: ownerType,
                    To: [
                      {
                        email: signatorEmail, name: proposedInsuredName
                      }]
                  }
                };
                try {
                  this.apiService.sendOwnerEmail(emailInfo).subscribe((response) => {
                    if (response.data.Message === 'Mail Sent') {
                      this.newRelicService.addPageAction('Owner Email Sent', { appId: this.appId });
                      console.log('success. mail sent');
                    } else {
                      this.commonService.logMessage(this.emailFailedMsg); //change to retry after
                    }
                  }, (error) => {
                    this.newRelicService.noticeError(error);
                    console.log(error);
                    this.commonService.logMessage(this.emailFailedMsg); //change to retry after
                  });
                } catch (e) {
                  this.newRelicService.noticeError(e);
                  console.log(e);
                  this.commonService.logMessage(this.emailFailedMsg); //change to retry after
                }
              });
            }
          }
        });
      }
    });
  }

  getOwnerType(owner, signingOfficer) {
    if (owner["PolicyOwnerType"] == 'Business') {
      return 'BusinessSignator';
    } else if (owner["PolicyOwnerType"] == 'ExistingTrust' || owner["PolicyOwnerType"] == 'TrustToBeEstablished') {
      const trusteeType = signingOfficer["TrusteeType"];
      console.log(trusteeType);
      if (trusteeType == 'Individual') {
        return 'IndividualTrustee';
      } else {
        return 'EntityTrustee';
      }
    } else if (owner["PolicyOwnerType"] == 'Other') {
      return 'Other';
    }
  }

  removeInsuredAppSubmittedQuestion() {
    try {
      const InsuredAppSubmittedOf = of(this.questions).pipe(map(items => items.filter(item => item.QuestionName == 'InsuredAppSubmitted')));

      InsuredAppSubmittedOf.subscribe((e: QuestionBase<any>[]) => {
        e[0].QuestionText = '';
        this.changeDetection.detectChanges();
      }, (error) => {
        this.newRelicService.noticeError(error);
        console.log('error', error);
        this.changeDetection.detectChanges();
      });
    } catch (error) {
      this.newRelicService.noticeError(error);
      console.log('error', error);
      this.changeDetection.detectChanges();
    }
  }

  getAgents() {
    try {
      this.processing = true;
      this.apiService.getApplicationAgents(this.appId).subscribe(response => {
        this.agentFirstName = 'Agent First Name not found ';
        this.agentLastName = 'Agent Last Name not found';
        this.agentPhone = '';

        if (response.data != null && response.data.Agents != null && response.data.Agents.length > 0) {
          this.agentFirstName = response.data.Agents[0].AgentFirstName;
          this.agentLastName = response.data.Agents[0].AgentLastName;
        }

        const agentNameOf = of(this.questions).pipe(map(items => items.filter(item => item.QuestionType == 'Label' && item.QuestionName == 'InsuredAppComplete')));

        agentNameOf.subscribe((e: QuestionBase<any>[]) => {
          this.processing = false;
          e[0].QuestionText = e[0].QuestionText.replace('{{ agentFirstName }}', this.agentFirstName);
          e[0].QuestionText = e[0].QuestionText.replace('{{ agentLastName }}', this.agentLastName);
          e[0].QuestionText = e[0].QuestionText.replace(' at {{ agentPhoneNumber }}', this.agentPhone);
          e[0].value = '';
          this.processing = false;
          this.questions = e;
          this.changeDetection.detectChanges();
        }, (error) => {
          this.newRelicService.noticeError(error);
          console.log('error', error);
          this.processing = false;
          this.changeDetection.detectChanges();
        });
      }, (error) => {
        this.newRelicService.noticeError(error);
        console.log('error', error);
        this.processing = false;
        this.changeDetection.detectChanges();
      });
    } catch (error) {
      this.newRelicService.noticeError(error);
      console.log('error', error);
      this.processing = false;
      this.changeDetection.detectChanges();
    }
  }

  demoThankYou() {
    try {
      this.processing = true;

      const agentNameOf = of(this.questions).pipe(map(items => items.filter(item => item.QuestionType == 'Label' && item.QuestionName == 'InsuredAppComplete')));

      agentNameOf.subscribe((e: QuestionBase<any>[]) => {
        this.processing = false;
        e[0].QuestionText = '<p><h2><b>Success! </b></h2></p><br/> <p> Once the proposed insured has signed the application, they will receive an on-screen confirmation message that they’ve successfully completed the signature process – and that you, the agent, have been notified. Please check your email for applicable next steps, including applying your signature as the agent.</p> <br/><br/><p><b><i>At this point in the John Hancock eApp, there are no further actions required by the customer. The remaining applications steps are only applicable to you (the agent). </i></b></p> ';
        e[0].value = '';
        this.processing = false;
        this.questions = e;
        this.changeDetection.detectChanges();
      }, (error) => {
        this.newRelicService.noticeError(error);
        console.log('error', error);
        this.processing = false;
        this.changeDetection.detectChanges();
      });
    } catch (error) {
      this.newRelicService.noticeError(error);
      console.log('error', error);
      this.processing = false;
      this.changeDetection.detectChanges();
    }
  }

  ownerThankYou() {
      try {
        this.processing = true;
        this.apiService.getApplicationAgents(this.appId).subscribe(response => {
          this.agentFirstName = 'Agent First Name not found ';
          this.agentLastName = 'Agent Last Name not found';
          this.agentPhone = '';
  
          if (response.data != null && response.data.Agents != null && response.data.Agents.length > 0) {
            this.agentFirstName = response.data.Agents[0].AgentFirstName;
            this.agentLastName = response.data.Agents[0].AgentLastName;
          }
                

          const agentNameOf = of(this.questions).pipe(map(items => items.filter(item => item.QuestionType == 'Label' && item.QuestionName == 'InsuredAppComplete')));
  
          agentNameOf.subscribe((e: QuestionBase<any>[]) => {
  
            this.processing = false;
            e[0].QuestionText = '<p><h2><b>Success! </b></h2></p><br/> <p> You have completed and signed the life insurance application for {{ firstName }} {{ lastName }}.</p><br> <h2><b> Next steps:</b> </h2> <ul> <li>Your insurance agent will receive a notification letting them know you have signed the application. They will follow a similar signature process before submitting the application to John Hancock for review.</li>  </ul> <p> If you have any questions, please contact  {{ agentFirstName }} {{ agentLastName }}. </p><br /> ';
            e[0].QuestionText = e[0].QuestionText.replace('{{ firstName }}', this.firstName);
            e[0].QuestionText = e[0].QuestionText.replace('{{ lastName }}', this.lastName);
            e[0].QuestionText = e[0].QuestionText.replace('{{ agentFirstName }}', this.agentFirstName);
            e[0].QuestionText = e[0].QuestionText.replace('{{ agentLastName }}', this.agentLastName);
            e[0].value = '';
             //this.processing = false;
            this.questions = e;
            this.changeDetection.detectChanges();
          }, (error) => {
            console.log('error', error); this.processing = false; this.changeDetection.detectChanges(); }
          );
          //check for pending jobs in jhade- needed to check for all owners signed
          const resumePayload = {
            AppId: this.appId,
            AppAuthId: this.appAuthId
          };
           this.checkForPendingJobs(resumePayload);
        }, (error) => {
          console.log('error', error); this.processing = false; this.changeDetection.detectChanges(); }
        );
      } catch (error) {
        console.log('error', error);
        this.processing = false;
        this.changeDetection.detectChanges();
      }
  }
}

